
import React from 'react';

type TeamMemberProps = {
  name: string;
  role: string;
  bio: string;
  image: string;
  catName?: string;
};

const TeamMember = ({ name, role, bio, image, catName }: TeamMemberProps) => {
  return (
    <div className="vintage-card h-full flex flex-col">
      <div className="relative mb-6 pb-[100%] overflow-hidden rounded-lg">
        <img
          src={image}
          alt={name}
          width={400}
          height={400}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
      </div>
      
      <h3 className="text-xl font-playfair font-bold">{name}</h3>
      <p className="text-accent font-medium mb-4">{role}</p>
      
      <p className="text-text/90 text-sm mb-4">{bio}</p>
      
      {catName && (
        <p className="mt-auto pt-3 border-t border-primary/10 text-primary font-medium">
          <span className="font-playfair italic">Cat: </span> {catName}
        </p>
      )}
    </div>
  );
};

export default TeamMember;
